// extracted by mini-css-extract-plugin
export default {"showcaseDiv":"MerchShowcase_showcaseDiv__VpRt2"};